export default __webpack_public_path__ + "static/media/yeopen_small@2x.37f13ffc.jpg";